export default __webpack_public_path__ + "static/media/SG19.4742db24.webp";